<fieldset *ngIf="annotationTable && annotationTable.length > 0" class="annotation-table">
  <legend>
    {{tableHeader}}

    <app-help-link [route]="'/documentation/genetic-and-physical-interactions'"
                   [title]="helpIconTitle">
    </app-help-link>
  </legend>

  <div *ngIf="interactionSources.length != 0" class="interaction-source">
    <span class="interaction-source-label">Source:</span>
    Interactions curated by
    <span *ngFor="let source of interactionSources; let i = index">
       <a href="{{source.url}}">{{source.name}}</a>
       <span *ngIf="i != interactionSources.length - 1">, </span>
    </span> and
    {{siteName}}
  </div>

  <a *ngIf="biogridUrl" class="biogrid-link" href="{{biogridUrl}}">
    View interactions for {{currentGene.displayName}} at BioGRID ...
  </a>

  <div>
    <div class="view-controls">
      <a *ngIf="currentViewState != TableViewState.Details" (click)="allDetailsView()">
        Show details ...
      </a>
      <a *ngIf="currentViewState == TableViewState.Details" (click)="allSummaryView()">
        Show summary ...
      </a>
    </div>

  <div class="filter-controls" *ngIf="filters">
    <app-genetic-interaction-table-filters
        [interactionTable]="annotationTable"
        [filters]="filters"
        (filterChange)="updateCurrentFilter($event)">
    </app-genetic-interaction-table-filters>
  </div>
  </div>

  <div *ngIf="queryLinkUrl" class="query-link">
    <a routerLink="{{queryLinkUrl}}">Query using interacting genes ...</a>
  </div>

  <div *ngIf="tableIsFiltered" class="filter-count">
    <span *ngIf="filteredTable.length == annotationTable.length">
      Showing all interactions
    </span>
    <span *ngIf="filteredTable.length != annotationTable.length">
      Showing {{filteredAnnotationCount}} of {{annotationCount}} interactions
    </span>
  </div>

  <div class="annotation-table-container">
  <table class="main-interaction-table">
    <thead>
      <tr>
        <th></th>
        <th>Gene</th>
        <th *ngIf="!currentGene">Product</th>
        <th></th>
        <th>Interacting gene</th>
        <th>Interacting product</th>
        <th>Interaction type</th>
      </tr>
    </thead>
    <tbody *ngFor="let annotation of displayTable">
      <tr>
        <td class="details-button">
          <a *ngIf="hasSomeDetails(annotation)" (click)="toggleDetails(annotation)">
            <span class="collapse-icon" *ngIf="detailsViewVisible(annotation)">-</span>
            <span class="collapse-icon" *ngIf="!detailsViewVisible(annotation)">+</span>
          </a>
        </td>
        <td>
          <app-gene-link class="app-link" [long]="false" [gene]="annotation.gene_a"></app-gene-link>
        </td>
        <td *ngIf="!currentGene">{{annotation.gene_a.product}}</td>
        <td class="interaction-directional-label">{{annotation.displayLabel}}</td>
        <td>
          <app-gene-link class="app-link" [long]="false" [gene]="annotation.gene_b"></app-gene-link>
        </td>
        <td class="interaction-product">{{annotation.gene_b.product}}</td>
        <td class="interaction-evidence">{{annotation.interaction_type}}</td>
      </tr>
      <tr *ngIf="detailsViewVisible(annotation)">
        <td></td>
        <td [attr.colspan]="!!currentGene ? 5 : 6">
          <div *ngIf="annotationHasOnlyReference(annotation)"
                class="genetic-interaction-detail genetic-interaction-detail-legacy-ref">
            Reference:
            <span *ngFor="let detail of annotation.details; let lastDetail = last">
              <span *ngIf="detail.reference">
                <app-reference-short [reference]="detail.reference"></app-reference-short>
                <span *ngIf="!lastDetail" class="reference-separator">|</span>
              </span>
            </span>
            <a [popover]="legacyRefHelp" class="help-link" triggers="mouseenter:mouseleave" placement="right"
               container="body"><img src="/assets/info_icon.svg">
               <ng-content></ng-content>
            </a>
          </div>
          <table *ngIf="!annotationHasOnlyReference(annotation)" class="genetic-interaction-detail">
            <thead>
              <tr>
                <th class="detail-double-genotype">
                  <span *ngIf="annotation.showColumn.has('double_mutant_genotype')">
                    Genotype
                  </span>
                </th>
                <th class="detail-double-phenotype">
                  <span *ngIf="annotation.showColumn.has('double_mutant_phenotype')">
                    Phenotype
                  </span>
                </th>
                <th class="detail-single-phenotype">
                  <span *ngIf="annotation.showColumn.has('rescued_phenotype')">
                    Single allele phenotype
                  </span>
                </th>
                <th *ngIf="annotation.showColumn.has('reference')" class="detail-reference">
                  Reference
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of annotation.details">
                <td class="detail-double-genotype">
                  <span *ngIf="detail.double_mutant_genotype">
                    <app-genotype-link [genotype]="detail.double_mutant_genotype">
                    </app-genotype-link>
                  </span>
                </td>
                <td class="detail-double-phenotype">
                  <span *ngIf="detail.double_mutant_phenotype">
                    <app-term-link [term]="detail.double_mutant_phenotype">
                      {{detail.double_mutant_phenotype.name}}
                   </app-term-link>
                   <div *ngIf="detail.double_mutant_extension" class="phenotype-extension">
                     <app-extension-display
                       [extension]="detail.double_mutant_extension"
                       [annotationTypeName]="annotationTypeName"
                       [geneDetails]="currentGene"
                       [highlightRelations]="true"></app-extension-display>
                   </div>
                 </span>
                </td>
                <td class="detail-single-phenotype">
                  <span *ngIf="detail.rescued_phenotype">
                    <app-term-link [term]="detail.rescued_phenotype">
                      {{detail.rescued_phenotype.name}}
                    </app-term-link>
                    <div *ngIf="detail.rescued_phenotype_extension" class="phenotype-extension">
                      <app-extension-display
                        [extension]="detail.rescued_phenotype_extension"
                        [annotationTypeName]="annotationTypeName"
                        [geneDetails]="currentGene"
                        [highlightRelations]="true"></app-extension-display>
                    </div>
                  </span>
                </td>
                <td *ngIf="annotation.showColumn.has('reference')" class="detail-reference">
                  <span *ngIf="detail.reference">
                    <app-reference-short [reference]="detail.reference"></app-reference-short>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
</fieldset>

<ng-template #legacyRefHelp>
  <div class="help-popover">
    <div>The genotype/phenotype details for this interaction are not currently curated</div>
  </div>
</ng-template>
